import { Link } from 'react-router-dom';
import { Clock, Mail, ArrowLeft } from 'lucide-react';

const RegistrationPending = () => {
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo-wrapper">
            <Clock size={64} style={{ color: '#f59e0b' }} />
          </div>
          <h1>Registration Submitted</h1>
        </div>

        <div style={{ textAlign: 'center', marginTop: '24px', padding: '24px', background: 'rgba(245, 158, 11, 0.1)', borderRadius: '8px', border: '1px solid rgba(245, 158, 11, 0.3)' }}>
          <Mail size={32} style={{ color: '#f59e0b', marginBottom: '16px' }} />
          <p style={{ color: 'var(--text-secondary)', marginBottom: '16px', lineHeight: '1.6' }}>
            Your registration has been submitted successfully.
          </p>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px', lineHeight: '1.6' }}>
            A member of our support team will review your request and be in touch shortly. 
            You will receive an email confirmation once your account has been approved.
          </p>
        </div>

        <div style={{ textAlign: 'center', marginTop: '32px' }}>
          <Link to="/login" className="btn btn-secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
            <ArrowLeft size={18} />
            Back to Login
          </Link>
        </div>

        <div className="login-footer">
          <p>Questions? Contact support@serverli.com</p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPending;
